import { Controller } from "@hotwired/stimulus"

// Manages modal overlay — close on ESC, close on background click
export default class extends Controller {
  static targets = ["panel"]

  close() {
    const wrapper = this.element.closest('[id$="_wrapper"]') || this.element.parentElement
    if (wrapper && wrapper.id.includes('modal')) {
      wrapper.classList.add('hidden')
    } else {
      this.element.classList.add('hidden')
    }
  }

  bgClose(event) {
    // Only close if clicking the backdrop, not the panel itself
    if (event.target === this.element) {
      this.close()
    }
  }

  stop(event) {
    event.stopPropagation()
  }
}
